import AppliedCoupons from './AppliedCoupons';

export default AppliedCoupons;
